<template>
  <div class="toolbar__group">
    <button
      aria-label="align left "
      class="toolbar__btn"
      type="button"
      @click="setAlignment('left')"
    >
      <alignLeft />
    </button>
    <button
      aria-label="align center"
      class="toolbar__btn"
      type="button"
      @click="setAlignment('center')"
    >
      <alignCenter />
    </button>
    <button
      aria-label="align right"
      class="toolbar__btn"
      type="button"
      @click="setAlignment('right')"
    >
      <alignRight />
    </button>
  </div>
</template>

<script>
import alignLeft from './icons/alignLeft.svg';
import alignCenter from './icons/alignCenter.svg';
import alignRight from './icons/alignRight.svg';
/**
 * this.selected could be the contentEditable wrapper
 * or the NodeEditor parent (element where class="node-editor__content").
 * We want to traverse through the children and return the element where
 * contentEditable is true so we can apply alignment to its contents.
 */
const findContentEditable = (el) => {
  let element = null;
  if (el.contentEditable === 'true') return el;
  for (var node of el.childNodes.values()) {
    if (node.contentEditable == 'true') {
      element = node;
      break;
    } else if (node.children && node.children.length > 0) {
      element = findContentEditable(node);
      break;
    }
  }
  return element;
};

/**
 * Applying alignment on a content editable requires moving content
 * to a div then applying style to that div. This is because the contentEditable
 * element is only a wrapper which is not saved to the node object but rather
 * the innerHTML is saved. (see onInput methods in any editing component)
 */
const applyToContentEditable = (node, propery) => {
  // content editable already has style applied
  if (
    node.childNodes[0].nodeName !== '#text' &&
    node.childNodes[0].dataset &&
    node.childNodes[0].dataset.format === 'alignment'
  ) {
    node.childNodes[0].style.textAlign = propery;
    return;
  }

  // wrap in a div
  const wrapper = document.createElement('div');
  wrapper.setAttribute('data-format', 'alignment');
  wrapper.style.textAlign = propery;
  wrapper.innerHTML = node.innerHTML;

  const containerContents = document.createRange();
  containerContents.selectNodeContents(node);
  containerContents.deleteContents();
  containerContents.insertNode(wrapper);
};

export default {
  name: 'Alignment',
  components: {
    alignLeft,
    alignCenter,
    alignRight,
  },
  props: {
    selected: {
      type: Range,
      default: () => new Range(),
    },
  },
  methods: {
    setAlignment(propery) {
      let contentEditable = findContentEditable(this.selected.commonAncestorContainer);
      // selection is content editable or selection is the full node
      if (contentEditable) {
        applyToContentEditable(contentEditable, propery);
      }
      // selection is text or block or text, apply the alignment to closest div ancestor
      else {
        // if its "text" node, start with the parent
        let element =
          this.selected.commonAncestorContainer.nodeType === 3
            ? this.selected.commonAncestorContainer.parentNode
            : this.selected.commonAncestorContainer;

        let closest = element.closest('div');
        closest.style.textAlign = propery;
        closest.setAttribute('data-format', 'alignment');
      }

      this.$emit('toolbar-action', propery);
    },
  },
};
</script>
